// extracted by mini-css-extract-plugin
export var menuIcon = "_ua-0";
export var menuIconInline = "_ua-1";